/* eslint-disabled */

import Pack from "@/entity/Pack";
import Coverage from "@/entity/Coverage";
import PackGuarantee from "@/entity/PackGuarantee";
import Risk from "@/entity/Risk";
import Guarantee from "@/entity/Guarantee";
import store from "@/store";
import ItemType from "@/entity/ItemType";
import PackCategory from "@/entity/PackCategory";
import {helper} from "@/services/Helper";

export default class CoverageExtend {


    details: any[] = []
    errors: any[] = []
    public optionalRisks: Array<Risk> = [];
    canSubscribe = true
    public category ?: PackCategory
    public insurer: any
    public expand = false
    packLabel = ''
    categoryLabel = ''
    insurerLabel = ''
    insurerUuid: any = ''

    constructor(object?: any) {
        if (object) {
            this.details = object.details
            this.errors = object.errors

            if (object.optionalRisks) {
                object.optionalRisks.forEach((occ: any) => {
                    const risk = occ instanceof Risk ? occ : new Risk(occ);
                    this.optionalRisks.push(risk);
                });
            }
            this.category = object.category
            this.packLabel = object.packLabel
            this.categoryLabel = object.categoryLabel
            this.insurerLabel = object.insurerLabel
            this.insurerUuid = object.insurerUuid
            this.insurer = object.insurer
            if (helper.empty(object.uuid)) {
                object.uuid = helper.generateId()
            }
        }
    }


    generateFromPack(pack: Pack) {
        const self: Coverage = this as any
        self.pack = pack
        self.risks = []
        self.label = pack.label
        pack.packGuarantees.forEach((pg: PackGuarantee) => {
            if (!pg.isOptional) {
                const risk = new Risk()
                risk.guarantee = pg.guarantee
                risk.label = pg.guarantee.label
                risk.minDescription = pg.deductible
                risk.maxDescription = pg.ceiling
                risk.isOptional = pg.isOptional
                self.risks.push(risk)
            }
        })
    }


    getRisk(guarantee: Guarantee) {
        const self: Coverage = this as any
        for (let risk of self.risks) {
            if (risk.guarantee.id === guarantee.id) {
                return risk
            }
        }
        for (let risk of self.optionalRisks) {
            if (risk.guarantee.id === guarantee.id) {
                return risk
            }
        }
    }

    // get premium() {
    //     const self: Coverage = this as any
    //     let premium = self.premium
    //     self.risks.forEach((risk: Risk) => {
    //         premium += risk.premium
    //     })
    //     return premium
    // }

    coverGuarantee(guarantee: Guarantee) {
        const self: Coverage = this as any
        const index = self.risks.findIndex((risk: Risk) => {
            return risk.guarantee.id === guarantee.id
        })
        return index !== -1
    }

    isGuaranteeOptional(guarantee: Guarantee) {
        const self: Coverage = this as any
        for (let risk of self.risks) {
            if (risk.guarantee.id === guarantee.id) {
                return risk.isOptional
            }
        }
        return null
    }

    getItem() {
        const self: Coverage = this as any
        const it = store.state.comparatorStore.itemTypes.find((i: ItemType) => {
            return i.code === 'coverage'
        })
        if (it) {
            const item = it.generateItem()
            item.setPropertyByCode('pack', self.pack?.code.toUpperCase())
            item.setPropertyByCode('risques', self.risks)
            return item
        }
    }

    simplify() {
        const self: Coverage = this as any

        return {
            uuid: self.uuid,
            pack: self.pack.id,
            category: self.category?.id,
            label: self.label ?? self.pack.label,
            risks: self.risks.map((risk: Risk) => ({
                uuid: risk.uuid,
                guarantee: risk.guarantee.id
            })),
            details: self.details,
            premium: self.premium
        }
    }

    postConstruct() {
        const self: Coverage = this as any
        if (helper.empty(self.uuid)) {
            self.uuid = helper.generateId()
        }
    }
}
